export default "/app/global-wrapper-client/static/eba3af16751210a6551ac0d8249a38e9.woff";